export const HeartBeatStatusEnum = {
  LOW_LATENCY: 'LOW_LATENCY',
  MEDIUM_LATENCY: 'MEDIUM_LATENCY',
  HIGH_LATENCY: 'HIGH_LATENCY',
  OFFLINE: 'OFFLINE',
} as const;
export type HeartBeatStatusEnum = (typeof HeartBeatStatusEnum)[keyof typeof HeartBeatStatusEnum];
